import { useSelector } from 'react-redux';
import { getStoreProducts } from '../../selectors';
import { SteamAppId, IStoreTypeRecord } from '../../interfaces/reducer.leaders.interfaces';
import { IStore } from 'store/interface';

export const useStoreFacade = (appId: SteamAppId | null) => ({
  entities: useSelector<IStore, IStoreTypeRecord>(store => getStoreProducts(store, appId)),
});
